"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("./style");
var _propTypes = require("prop-types");
var _AdImage = require("../../molecules/AdImage");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ProductInfo = exports.ProductInfo = function ProductInfo(_ref) {
  var adStatus = _ref.adStatus,
    image = _ref.image,
    firstLine = _ref.firstLine,
    secondLine = _ref.secondLine,
    _ref$thirdLine = _ref.thirdLine,
    thirdLine = _ref$thirdLine === void 0 ? null : _ref$thirdLine,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'ltr' : _ref$direction,
    imageSize = _ref.imageSize;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    direction: direction,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AdImage.AdImage, {
      image: image,
      adStatus: adStatus,
      imageSize: imageSize
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.TextWrapper, {
      direction: direction,
      imageSize: imageSize,
      children: [firstLine, secondLine, thirdLine ? thirdLine : null]
    })]
  });
};
ProductInfo.propTypes = {
  image: _propTypes.string,
  firstLine: _propTypes.element.isRequired,
  secondLine: _propTypes.element.isRequired,
  thirdLine: _propTypes.element,
  direction: (0, _propTypes.oneOf)(['ltr', 'rtl']),
  imageSize: (0, _propTypes.oneOf)(['large', 'small'])
};